import { render, staticRenderFns } from "./NutrientRequirement.vue?vue&type=template&id=7fcc9aa0&lang=html&"
import script from "./NutrientRequirement.vue?vue&type=script&lang=js&"
export * from "./NutrientRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports